<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";

import { required } from "vuelidate/lib/validators";

export default {
  page: {
    title: "External Employees",
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "External Employees",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "External Employees",
          active: true,
        },
      ],
      tableData: [],
      provinceSelection: [],
      citySelection: [],
      barangaySelection: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        {
          key: "item",
          sortable: true,
          label: "",
          thStyle: { width: "50px" },
        },
        {
          key: "campusName",
          sortable: true,
          label: `${this.GLOBAL_FROM_SCHOOL ? "Campus" : "Main Office"} Name`,
        },
        {
          key: "shortName",
          sortable: true,
          label: "Short Name",
        },
        {
          key: "location",
          sortable: true,
          label: "Location",
        },
      ],
      external: {
        employeeIdNumber: "",
        code: 0,
      },
      barangay: {},
      city: {},
      province: {},
      region: {},
      indexSelected: -1,
      tableBusy: false,
      selectedCampus: {},
      selectedEmployee: {},

      // office
      office: {
        id: 0,
        name: "",
        shortName: "",
        campusId: 0,
      },
      selectedOffice: {},
      // delivery Unit
      du: {
        id: 0,
        name: "",
        shortName: "",
        officeId: 0,
      },
      selectedDU: {},

      // department
      department: {
        id: 0,
        departmentName: "",
        shortName: "",
        deliveryUnitId: 0,
      },
    };
  },
  validations: {
    external: {
      employeeIdNumber: { required },
    },
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  created() {
    this.totalRows = this.items.length;
    this.tableBusy = true;
    this.$store
      .dispatch("campus/GetCampusByAgency", this.$store.state.data.agency.id)
      .then((res) => {
        res.data.forEach((item) => {
          item.location = `${item.barangay}, ${item.city}, ${item.province}, ${item.region}, ${item.zipcode}`;
          item.rotateChevy = false;
          item.offices = [];
        });
        this.tableData = res.data;
        this.tableBusy = false;
      })
      .catch(() => {
        this.showToast("Something went wrong! Cannot fetch office", "error");
        this.tableBusy = false;
      });
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addExternal(code) {
      if (code === 0) {
        this.onReset();
        this.modalTitle = "Add External Employee";
        this.external.code = 0;
      }

      if (code === 1) {
        this.modalTitle = "Update External Employee";
        this.external.code = 1;
      }

      this.$bvModal.show("modal-standard");
    },
    updateEmployee(id) {
      this.external.code = 1;
      this.external.employeeIdNumber = id;
      this.onCreate();
      this.$bvModal.hide("view-modal");
    },
    deleteEmployee(data) {
      this.$swal({
        title: "Are you sure?",
        html: `Are you sure you want to delete [<span class="text-info">${data.idNo}</span>] - <span class="text-warning">${data.lastName}, ${data.firstName}</span>? You won't be able to revert this!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("externalemployee/deleteExternalEmployee", data.id)
            .then(() => {
              const obj = this.tableData
                .find((item) => item.hrisId === data.campusId)
                .offices.find((office) => office.officeId === data.officeId);

              obj.dus.splice(obj.dus.indexOf(data), 1);
              this.$bvModal.hide("view-modal");
              this.showToast("Successfully deleted!", "success");
            })
            .catch(() => {
              this.$bvModal.hide("view-modal");
              this.showToast("Something went wrong. Cannot delete Employee", "error");
            });
        }
      });
    },
    onCreate() {
      this.submitted = true;
      this.$v.external.$touch();
      if (this.$v.external.$invalid) {
        return;
      } else {
        if (this.external.code === 1) {
          /** UPDATE */
          this.$store
            .dispatch("externalemployee/updateExternalEmployee", {
              EmployeeIdNumber: this.external.employeeIdNumber,
            })
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              if (!res.data.idNo) {
                return this.showToast("Employee not found", "error");
              }
              this.$bvModal.hide("modal-standard");
              this.showToast("Successfully updated!", "success");
            })
            .catch((err) => {
              this.showToast(
                "Something went wrong! Cannot update external employee",
                "error"
              );
            });
        } else {
          /** CREATE */
          this.$store
            .dispatch("externalemployee/addExternalEmployee", {
              employeeIdNumber: this.external.employeeIdNumber,
            })
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              if (!res.data.idNo) {
                return this.showToast("Employee not found", "error");
              }
              this.$bvModal.hide("modal-standard");
              this.showToast("External Employee Successfully Added!", "success");
            })
            .catch((err) => {
              this.showToast(
                "Something went wrong! Cannot add external employee",
                "error"
              );
            });
        }
        this.submitted = false;
      }
    },
    onReset() {},
    hideModal() {
      this.external = {
        employeeIdNumber: "",
        code: 0,
      };
      this.$v.$reset();
      this.$bvModal.hide("modal-standard");
    },

    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      row.toggleDetails();
      if (row.item.rotateChevy) {
        this.getOffices(row.item);
      }
    },
    getOffices(row) {
      this.$store
        .dispatch("externalemployee/getOfficesByCampus", row.id)
        .then((res) => {
          res.data.forEach((item) => {
            item.showDtls = false;
            item.dus = [];
          });
          row.offices = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    getDUs(row) {
      row.showDtls = !row.showDtls;
      this.$store
        .dispatch("externalemployee/getEmployeeByOfficeandCampus", {
          officeId: row.officeId,
          campusId: row.campusId,
        })
        .then((res) => {
          row.dus = res.data;
          this.tableBusy = false;
        })
        .catch(() => {
          this.showToast("Fetching External Employees Went wrong!", "error");
          this.tableBusy = false;
        });
    },
    getEmployeeDetails(record) {
      this.$bvModal.show("view-modal");
      this.selectedEmployee = record;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card border">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="card-title m-0">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} List</h4>
              <div id="external-buttons" class="d-flex align-items-center">
                <b-button
                  variant="primary"
                  size="sm"
                  @click="addExternal(0)"
                  class="me-2"
                >
                  <i class="bx bx-plus fs-6 align-middle me-1"></i>Add Employee
                </b-button>
                <b-button variant="outline-warning" size="sm" @click="addExternal(1)">
                  <i class="bx bx-edit fs-6 align-middle me-1"></i>Update Employee
                </b-button>
                <!-- Manage Employee -->
                <b-modal
                  id="modal-standard"
                  :title="modalTitle"
                  size="md"
                  hide-footer
                  no-close-on-backdrop
                >
                  <form @submit.prevent="onCreate" class="needs-validation" ref="fcForm">
                    <div class="mb-3">
                      <label for="campusName">ID Number </label>
                      <input
                        autocomplete="off"
                        id="campusName"
                        type="text"
                        v-model="external.employeeIdNumber"
                        placeholder="Enter Employee ID..."
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.external.employeeIdNumber.$error,
                        }"
                      />
                      <div
                        v-if="submitted && $v.external.employeeIdNumber.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.external.employeeIdNumber.required"
                          >This value is required.</span
                        >
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">Submit</button>
                      <button type="button" class="btn btn-link" @click="hideModal">
                        Close
                      </button>
                    </div>
                  </form>
                </b-modal>
                <!-- View Employee -->
                <b-modal
                  id="view-modal"
                  title="External Employee Detail"
                  size="md"
                  hide-footer
                >
                  <div v-if="selectedEmployee && selectedEmployee.firstName">
                    <div class="d-flex align-items-center">
                      <div class="avatar-sm me-2">
                        <span
                          class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-16"
                          >{{ selectedEmployee.firstName.charAt(0).toUpperCase()
                          }}{{ selectedEmployee.lastName.charAt(0).toUpperCase() }}</span
                        >
                      </div>
                      <div>
                        <div class="mt-1">
                          <h5 class="mb-0">
                            {{
                              selectedEmployee.lastName.charAt(0).toUpperCase() +
                              selectedEmployee.lastName.slice(1)
                            }},
                            {{
                              selectedEmployee.firstName.charAt(0).toUpperCase() +
                              selectedEmployee.firstName.slice(1)
                            }}
                            {{
                              selectedEmployee.middleName
                                ? `${selectedEmployee.middleName
                                    .charAt(0)
                                    .toUpperCase()}.`
                                : ""
                            }}
                          </h5>
                        </div>
                        <div>{{ selectedEmployee.idNo }}</div>
                      </div>
                    </div>
                    <hr class="my-3" />
                    <div class="ps-3 pe-3">
                      <b-row class="mb-2">
                        <b-col class="p-0" sm="2">
                          <b>Office</b>
                        </b-col>
                        <b-col
                          :class="{
                            'text-white': selectedEmployee.office,
                          }"
                          >{{
                            selectedEmployee.office
                              ? selectedEmployee.office
                              : "No record"
                          }}</b-col
                        >
                      </b-row>
                      <b-row class="mb-2">
                        <b-col class="p-0" sm="2">
                          <b>Position</b>
                        </b-col>
                        <b-col
                          :class="{
                            'text-white': selectedEmployee.position,
                          }"
                          >{{
                            selectedEmployee.position
                              ? selectedEmployee.position
                              : "No record"
                          }}</b-col
                        >
                      </b-row>
                    </div>
                    <div class="modal-footer">
                      <b-button
                        variant="danger"
                        @click="deleteEmployee(selectedEmployee)"
                      >
                        <i class="bx bx-trash fs-6 align-middle me-1"></i>Delete
                      </b-button>
                      <b-button
                        variant="outline-warning"
                        @click="updateEmployee(selectedEmployee.idNo)"
                      >
                        <i class="bx bx-edit fs-6 align-middle me-1"></i>Update
                      </b-button>
                    </div>
                  </div>
                </b-modal>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      autocomplete="off"
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :busy="tableBusy"
                @filtered="onFiltered"
                bordered
                outlined
                hover
                striped
                show-empty
              >
                <template #empty="scope">
                  <div class="text-center">
                    {{ scope.emptyText }}
                  </div>
                </template>
                <template #table-busy>
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-20px h-20px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #cell(item)="row">
                  <div
                    class="d-flex align-items-center justify-content-center"
                    @click="showDtls(row)"
                  >
                    <i
                      class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
                      :class="{
                        'rotate-90': row.item.rotateChevy,
                      }"
                    ></i>
                  </div>
                </template>
                <template #row-details="row">
                  <div class="card">
                    <div
                      class="card-header d-flex align-items-center justify-content-between"
                    >
                      <h5 class="card-title mb-0">List of Offices</h5>
                    </div>
                    <div class="card-body px-3 py-2">
                      <div v-for="x in row.item.offices" :key="x.id">
                        <div class="d-flex align-items-center hover-toggle">
                          <div
                            class="font-size-15 cursor-pointer d-flex align-items-center text-info"
                            @click="getDUs(x)"
                          >
                            <i
                              class="bx bx-chevron-right me-1 rotate"
                              :class="{
                                'rotate-90': x.showDtls,
                              }"
                            ></i
                            >{{ x.officeName }}
                          </div>
                        </div>
                        <div v-if="x.showDtls">
                          <div v-for="y in x.dus" :key="`X${x.id}Y${y.id}`" class="ms-3">
                            <div class="d-flex align-items-center">
                              <div
                                class="font-size-13 d-flex align-items-center my-1 cursor-pointer"
                                @click="getEmployeeDetails(y)"
                              >
                                <!-- <i class="bx bx-chevron-right me-1"></i> -->
                                <span class="badge rounded-pill bg-primary me-2">{{
                                  y.idNo
                                }}</span>
                                -
                                <span class="ms-2 me-2 text-warning">{{
                                  `${y.firstName} ${y.middleName} ${y.lastName}`
                                }}</span>
                                |
                                <span class="ms-2">{{ y.position }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
